import { withAuthorization } from "../../../authentication/Session/withAuthorization";
import { getAuthorizationGuard } from "../../../authentication/authorizations";
import { Role } from "@farmact/model/src/model/Role";
import { lazy } from "react";
import { DefaultPage } from "../../../structure/Page/DefaultPage/DefaultPage";

const ResourceDetailsPageContent = lazy(() => import("./ResourceDetailsPageContent"));

function ResourceDetailsPageInternal() {
    return (
        <DefaultPage>
            <ResourceDetailsPageContent />
        </DefaultPage>
    );
}

export const ResourceDetailsPage = withAuthorization(
    getAuthorizationGuard(Role.OWNER, Role.ADMIN, Role.PLANNER, Role.EMPLOYEE)
)(ResourceDetailsPageInternal);
